exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-755472fc]{font-size:15px;text-align:justify}.span[data-v-755472fc]{color:#fff}.input[data-v-755472fc],.span[data-v-755472fc]{font-size:30px}.input[data-v-755472fc]{height:40px;width:350px}", ""]);

// exports
